import { Component } from '@angular/core';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';

@Component({
  selector: 'app-access-denied-component',
 
  templateUrl: './access-denied-component.component.html',
  styleUrl: './access-denied-component.component.scss',
  standalone:true,
  imports:[...PRIMENG_MODULES]
})
export class AccessDeniedComponentComponent {

}
